<template>
  <div>
    <navbar></navbar>
    <div class="sidenav">
      <!-- <div class="sidenav-item header">Styles</div> -->
      <div class="sidenav-item"
       v-for="(section, index) in sections"
       :key="section.title"
       >
        <a :href="'#' + section.title">{{section.title}}</a>
        <div v-if="index < (sections.length - 1)" class="dot"></div>
      </div>
    </div>
    <div class="content">
      <router-link class="edit-button"
        to="/edit-gallery" v-if="token">Edit Gallery</router-link>
      <h2>Pieces by Marcia Halperin</h2>
      <div class="section-container">
        <div class="section"
             v-for="(section, sectionIndex) in sections"
             :key="section.title">
          <h3 class="section-title" :id="section.title">{{ section.title }}</h3>
          <div class="piece-list">
            <piece
              :piece="piece"
              :img-prefix="imgPrefix"
              @click.native="selectPiece(sectionIndex, pieceIndex)"
              v-for="(piece, pieceIndex) in section.pieces"
              :key="piece.url"
            ></piece>
          </div>
        </div>
      </div>
    </div>
    <modal
      v-if="selected"
      :urlPrefix="imgPrefix"
      :piece="sections[selected.section].pieces[selected.piece]"
      @close="selected = null"
      @moveLeft="onMoveLeft()"
      @moveRight="onMoveRight()"
      ></modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import PieceComponent from './Piece';

const piecesUrl = 'https://s3.amazonaws.com/marcia-pottery/pieces.json';

export default {
  components: {
    piece: PieceComponent,
  },
  computed: mapState({
    token: state => state.auth.authToken,
  }),
  methods: {
    ...mapActions([
    ]),
    selectPiece(sectionIndex, pieceIndex) {
      this.selected = {
        section: sectionIndex,
        piece: pieceIndex,
      };
    },
    onMoveLeft() {
      if (this.selected.piece > 0) {
        this.selected = {
          section: this.selected.section,
          piece: this.selected.piece - 1,
        };
      } else if (this.selected.section > 0) {
        const section = this.selected.section - 1;
        this.selected = {
          section,
          piece: this.sections[section].pieces.length - 1,
        };
      }
    },
    onMoveRight() {
      if (
        this.selected.piece <
        this.sections[this.selected.section].pieces.length - 1
      ) {
        this.selected = {
          section: this.selected.section,
          piece: this.selected.piece + 1,
        };
      } else if (this.selected.section < this.sections.length - 1) {
        this.selected = {
          section: this.selected.section + 1,
          piece: 0,
        };
      }
    },
  },
  mounted() {
    axios({
      method: 'get',
      url: piecesUrl,
    }).then(res => {
      this.sections = res.data.sections;
    });
  },
  data() {
    return {
      keyListener: null,
      selected: null,
      imgPrefix: 'https://s3.amazonaws.com/marcia-pottery/images/',
      sections: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-left: 3em;
  text-align: center;
}
.section {
  padding: 1em 1em 1em 1em;
  display: flex;
  flex-direction: column;
}
.edit-button {
  display: block;
  width: 7em;
  margin: 1em auto;
  padding: 1em;
  background: white;
  border: 1px solid black;
  border-radius: 3px;
  box-shadow: 2px 2px 2px #bbb;
  cursor: pointer;
  text-decoration: none;
  color: blue;
  &:active {
    background: #ddd;
    box-shadow: inset 2px 2px #bbb;
  }
}
.piece-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: baseline;
}
.sidenav {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  padding: 1em;
}
.sidenav-item {
  display: flex;
  flex-direction: column;
  a {
    text-decoration: initial;
    color: $text-base;
  }
  font-weight: 700;
  .dot {
    width: 4px;
    height: 4px;
    margin: 1em;
    border-radius: 50%;
    background: black;
    align-self: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue?9268db68